import { useContext } from 'react'

import { backendFetchResult } from './api'
import { anyWindow } from './helpers'
import { uiPropsNewUserOverwrites } from './new-user-test-data'
import { SystemData, UiProps, UiPropsContext } from './SystemData'

export const patchUiProps = async (props: UiProps) => {
  const body = JSON.stringify({ props })
  await backendFetchResult('PATCH', '/shop/ui-props', { body })
}

type UiPropState<K extends keyof UiProps> = {
  value: UiProps[K] | undefined
  patch: (propValue: UiProps[K]) => Promise<void>
}

export const useUiProp = <K extends keyof UiProps>(propKey: K): UiPropState<K> => {
  const { uiProps, setUiProps } = useContext(UiPropsContext)

  const patchUiProp = async (propValue: UiProps[K]) => {
    const newProps = { ...uiProps, [propKey]: propValue } as UiProps
    setUiProps(newProps)
    patchUiProps(newProps)
  }

  return {
    value: uiProps?.[propKey] as UiProps[K] | undefined,
    patch: patchUiProp,
  }
}

export const getUiPropsFromData = (data?: SystemData): UiProps | undefined => {
  const uiProps = data?.uiProps

  if (anyWindow.newUserTest) {
    return { ...uiProps, ...uiPropsNewUserOverwrites }
  }

  return uiProps
}
